/**
 * Progressive Button on click
 * @module progressiveButton
 */

import $ from 'jquery';

import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options.js';

export const PLUGIN_NAME = 'progressiveButton';
export const CLICK_HANDLER = 'click';
export const DEFAULTS = {
  time: 2000,
};


/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const progressiveFlow = ($el, options) => {
  // Get button-specific data attributes
  const onLoadSelector = $el.data('on-load-state');
  const finalBtnSelector = $el.data('final-state');
  const textSubmit = $el.data('text-on-submit');

  // Find closest parent container to scope the selectors
  const $elParent = $el.closest('.js-progressive-button__container');
  const $container = $elParent.length ? $elParent : $el.parent();

  // Find elements within the same container instead of global document
  const $onLoad = $container.find(onLoadSelector);
  const $finalBtn = $container.find(finalBtnSelector);

  setTimeout(() => {
    $el.attr('disabled', true);
  });

  // if there's another button to show,
  // hide the original button
  if (finalBtnSelector) {
    $el.hide();
  }

  $onLoad.removeClass('u-hide');

  if (textSubmit) {
    if ($el.is('input')) {
      $el.val(textSubmit);
    } else {
      $el.text(textSubmit);
    }
  }

  if (finalBtnSelector) {
    setTimeout(() => {
      $onLoad.hide();
      $finalBtn.removeClass('u-hide');
    }, options.time);
  }
};

const reset = ($el) => {
  // Get button-specific data attributes directly from the element
  const onLoadSelector = $el.data('on-load-state');
  const finalBtnSelector = $el.data('final-state');
  const dataText = $el.data('text');

  setTimeout(() => {
    $el.removeAttr('disabled');
  });
  if (dataText) {
    if ($el.is('input')) {
      $el.val(dataText);
    } else {
      $el.text(dataText);
    }
  }
  if (finalBtnSelector) {
    $el.show();
  }
  $(onLoadSelector).removeClass('u-inline-block');
  $(onLoadSelector).addClass('u-hide');
};

const setEventListeners = ($el, options) => {
  $el.on(CLICK_HANDLER, (e) => {
    e.stopPropagation();
    progressiveFlow($el, options);
  });
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the button
 * @see DEFAULTS
 */
export default function progressiveButton(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  return {
    reset: () => reset($el),
    // Mock Content Start - AB Test 400
    run: () => progressiveFlow($el, opts),
    // Mock Content End - AB Test 400
  };
}
registerJQueryPlugin(PLUGIN_NAME, progressiveButton);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/progressiveButton.js